import {
    createSubpatient,
    NewSubpatientFormTrackingActionCreators,
} from './NewSubpatientFormActions';
import { wrapWithDispatch } from '../../utils';

const mapDispatchToProps = dispatch => ({
    onContinue: (mainPatientId, subpatient) => {
        dispatch(createSubpatient(mainPatientId, subpatient));
    },
    ...wrapWithDispatch(NewSubpatientFormTrackingActionCreators, dispatch),
});

export default mapDispatchToProps;
